import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn, ShieldCheck } from "lucide-react";
import { useAuth } from "@/lib/AuthContext";
import { useSeo } from "@/lib/useSeo";

export default function AdminLogin() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  useSeo({ title: "Administration", description: "Espace d'administration réservé.", path: "/admin" });

  useEffect(() => {
    if (!loading && user?.is_admin) navigate("/admin/dashboard", { replace: true });
  }, [user, loading, navigate]);

  const login = () => {
    const redirectUrl = `${window.location.origin}/admin/dashboard`;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050814] dl-noise p-6">
      <div className="relative z-10 w-full max-w-md border border-[rgba(198,167,106,0.25)] bg-[#0B1020] p-10 text-center">
        <ShieldCheck size={34} className="text-[#C6A76A] mx-auto mb-5" />
        <div className="dl-eyebrow mb-2">Espace privé</div>
        <h1 className="serif text-3xl text-[#F3E9D2]">Administration</h1>
        <p className="text-sm text-[#F3E9D2]/60 mt-3 mb-8">
          Connectez-vous avec votre compte Google pour gérer le contenu du site.
        </p>
        <button data-testid="admin-google-login-btn" onClick={login} className="dl-btn dl-btn-solid w-full justify-center">
          <LogIn size={16} /> Se connecter avec Google
        </button>
        {!loading && user && !user.is_admin && (
          <p className="text-[#e0a0a0] text-sm mt-5">Ce compte n'a pas les droits d'administration.</p>
        )}
      </div>
    </div>
  );
}
